import "../sections/sections.css";
import "./privacy.css";

import React from "react";

import { PRIVACY } from "../../data/privacy";
import PageMeta from "../general/PageMeta";
import SectionTitle from "../general/SectionTitle";
import PageHero from "../sections/PageHero";

const REGULATOR_LINK = "https://www.justice.gov.za/inforeg/";

//Makes the Information Regulator address clickable (plain text on Wix)
const withLink = (text) => {
  const at = text.indexOf(REGULATOR_LINK);
  if (at < 0) {
    return text;
  }
  return (
    <React.Fragment>
      {text.slice(0, at)}
      <a
        href={REGULATOR_LINK}
        target={"_blank"}
        rel={"noopener noreferrer"}
      >
        {REGULATOR_LINK}
      </a>
      {text.slice(at + REGULATOR_LINK.length)}
    </React.Fragment>
  );
};

const Privacy = () => (
  <React.Fragment>
    <PageMeta
      title={PRIVACY.TITLE}
      description={"Estia Events (Pty) Ltd Data Subject POPIA Clause (consent and notification)."}
    />
    <PageHero
      image={{ src: "/images/heroes/background-estia-events.webp", width: 1903, height: 1000 }}
      title={PRIVACY.TITLE}
    />
    <section className={"privacy"}>
      <div className={"container"}>
        <SectionTitle subtitle={PRIVACY.SUBTITLE[1]}>{PRIVACY.SUBTITLE[0]}</SectionTitle>
        <div className={"privacy-body"}>
          {PRIVACY.BLOCKS.map((block, i) => {
            if (block.heading) {
              return <h3 key={i}>{block.heading}</h3>;
            }
            if (block.list) {
              return (
                <ul key={i}>
                  {block.list.map((item) => <li key={item}>{item}</li>)}
                </ul>
              );
            }
            return <p key={i}>{withLink(block.text)}</p>;
          })}
        </div>
      </div>
    </section>
  </React.Fragment>
);

export default Privacy;
